module.exports = __webpack_public_path__ + "static/media/apolloMobile.1b3528e8.png";